import _ from "lodash"
import { getEvent } from 'api/functions/functions';
import MainContext from 'context/MainContext';
import { useEffect, useContext, useState } from 'react';
import { consoleLog } from "utils/functions";

function useEventHandler() {

    const context = useContext(MainContext)
    const [event, setEvent] = useState()

    useEffect(() => {
        if (!_.isEmpty(context.evt)) {
            setEvent(context.evt.id)
        }
    }, [context.evt])

    const loadEventData = async () => {
        context.setLoadingEventData(true)

        consoleLog("client.get loadEventData 1");
        const res = await getEvent(event);
        consoleLog("client.get loadEventData 2", res);
        if (res) {
            context.setEvent(res);
        }
        context.setLoadingEventData(false)
    }

    return {
        _loading: context.loadingEventData,
        _loadEventData: () => loadEventData(),
    };
}

export default useEventHandler